const MEDALS = ['🥇', '🥈', '🥉'];

export default function FinalView({ room }) {
  if (!room) return null;
  const participants = room.participants ?? [];
  const ranked = participants
    .slice()
    .sort((a, b) => (room.totalScores[b.id] ?? 0) - (room.totalScores[a.id] ?? 0));

  const topScore = room.totalScores[ranked[0]?.id] ?? 0;

  return (
    <div className="min-h-screen tv-bg-dot flex flex-col items-center p-4 gap-4">
      <div className="tv-ribbon text-3xl mt-8 mb-2">最終結果！</div>

      {ranked[0] && (
        <div className="tv-panel p-6 flex flex-col items-center gap-2 w-full max-w-xs">
          <span className="text-5xl">{ranked[0].emoji}</span>
          <p className="tv-heading text-2xl">{ranked[0].nickname}</p>
          <p className="font-num text-3xl text-tv-blue font-bold">{topScore}pt</p>
          <p className="text-yellow-500 text-4xl">🎉🎊🎉</p>
        </div>
      )}

      <div className="w-full max-w-sm flex flex-col gap-2">
        {ranked.slice(1).map((p, i) => (
          <div key={p.id} className="tv-panel-sm p-3 flex items-center gap-3">
            <span className="text-xl w-8 text-center">
              {i + 1 < 3 ? MEDALS[i + 1] : `${i + 2}位`}
            </span>
            <span className="text-2xl">{p.emoji}</span>
            <span className="flex-1 font-body font-bold truncate">{p.nickname}</span>
            <span className="font-num font-bold text-tv-blue">
              {room.totalScores[p.id] ?? 0}pt
            </span>
          </div>
        ))}
      </div>

      <p className="text-tv-ash font-body text-sm mt-4">お疲れさまでした！</p>
    </div>
  );
}
